import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DriveEventService } from 'src/app/services/drive-event/drive-event.service';
import { AddInstitutionDialogComponent } from '../add-institution-dialog/add-institution-dialog.component';
import { DownloadXlsxComponent } from '../download-xlsx/download-xlsx.component';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { DriveService } from 'src/app/services/drive/drive.service';
import { ActivatedRoute } from '@angular/router';
import { AddBranchComponent } from '../add-branch/add-branch.component';
@Component({
  selector: 'app-drive-container',
  templateUrl: './drive-container.component.html',
  styleUrls: ['./drive-container.component.scss']
})
export class DriveContainerComponent implements OnInit {
  Registration = 0;
  RegistrationAttended = 0;
  RegistrationSelected = 0;
  walkinAttended = 0;
  walkingSelected = 0;
  type = '';
  id = '';
  funnelData: any;
  count = 0;

  visibilityForLeftIcon = false;
  visibilityForRightIcon = true;

  viewFlag: boolean = false;
  constructor(
    public dialog: MatDialog,
    public driveEventService: DriveEventService,
    private utility: UtilityService,
    private campaignService: CampaignService,
    private driveService: DriveService,
    private route: ActivatedRoute,
  ) {

  }
  data: any = { 'institutionName': '' };
  recentDriveData: any[] = [];
  funnelDriveData: any;
  ngOnInit() {

    this.type = this.route.snapshot.paramMap.get('type');
    this.id = this.route.snapshot.paramMap.get('id');
    // this.getData();
    this.getCollegeData();
    this.getRecentDetailsData();

    this.driveService.currentData.subscribe(
      response => {
        console.log('response at drive container: ', response);

        this.getRecentDetailsData();
      }
    );
  }

  getCollegeData() {
    this.utility.showSpinner();
    this.campaignService.getDetailsByTypeAndId(this.type, this.id)
      .subscribe(response => {
        console.log('getDetailsByTypeAndId', response);
        this.data = (response as any).data;
        this.utility.hideSpinner();
      });
  }

  getRecentDetailsData() {
    this.utility.showSpinner();
    this.driveService.getDrivesByInstitutionId(this.id)
      .subscribe(response => {

        this.recentDriveData = (response as any).data;
        console.log("recentdrive data",this.recentDriveData)
        this.recentDriveData = this.recentDriveData.reverse();
        console.log('getDrivesByInstitutionId' , this.recentDriveData );
        if (this.recentDriveData.length > 0) {
          this.getFunnelDetailsData(this.recentDriveData[0].id);
        }
        this.utility.hideSpinner();
      });
  }


  receiveBranchData($event){
    console.log("event at drive container: ", $event.id);
    this.recentDriveData[0].checked = true;

    if(this.recentDriveData[0].id != undefined){
    for(let i=0 ; i < this.recentDriveData.length ; i++ ){
      if(this.recentDriveData[i].id !== $event.id){
        this.recentDriveData[i].checked = false
      }
    }
  }
    let driveId = $event.id;
    this.utility.showSpinner();
    this.driveService.getDriveFunnelData(driveId)
      .subscribe(response => {

        this.funnelDriveData = (response as any).data;
        console.log('getFunnelDetailsData', this.funnelDriveData);

        if (this.funnelDriveData.registeredUsers.length === 0) {
          this.Registration = 0;
          this.RegistrationAttended = 0;
          this.RegistrationSelected = 0;
        } else {
          // console.log("this.funnelDriveData.hiringDrive.selectedUsers.length: ", this.funnelDriveData.hiringDrive.selectedUsers.length);
          // console.log("this.funnelDriveData.hiringDrive.registeredUsers.length ",
          // this.funnelDriveData.hiringDrive.registeredUsers.length);
          // console.log("this.funnelDriveData.hiringDrive.attendedUsers.length ", this.funnelDriveData.hiringDrive.attendedUsers.length);


          this.Registration = 100;
          // console.log("Funnel1",this.funnelDriveData.hiringDrive.selectedUsers.length);
          // console.log("Funnel2",this.funnelDriveData.hiringDrive.registeredUsers.length);
          // console.log("funnel3",(this.funnelDriveData.hiringDrive.selectedUsers.length /
          // this.funnelDriveData.hiringDrive.registeredUsers.length) * 100);


          this.RegistrationAttended = (this.funnelDriveData.attendedUsers.length / this.funnelDriveData.registeredUsers.length) * 100;
          // / 100;
          if (this.funnelDriveData.attendedUsers.length !== 0) {
            this.RegistrationSelected = (this.funnelDriveData.selectedUsers.length / this.funnelDriveData.attendedUsers.length) * 100;
            // / 100;
            this.RegistrationSelected = Math.floor(this.RegistrationSelected);
            this.RegistrationAttended = Math.floor(this.RegistrationAttended);

          } else {
            this.RegistrationSelected = 0;

          }
          // console.log("value of this.RegistrationSelected : ", this.RegistrationSelected);

        }

        if (this.funnelDriveData.walkinUsers.length === 0) {
          this.walkinAttended = 0;
          this.walkingSelected = 0;
        } else {
          this.walkinAttended = 100;
          this.walkingSelected = (this.funnelDriveData.walkinSelected.length / this.funnelDriveData.walkinUsers.length) * 100; // / 100;
          this.walkingSelected = Math.floor(this.walkingSelected);

        }
        this.utility.hideSpinner();
      });
  }
  getFunnelDetailsData(driveId) {
    this.utility.showSpinner();
    this.driveService.getDriveFunnelData(driveId)
      .subscribe(response => {

        this.funnelDriveData = (response as any).data;
        console.log('getFunnelDetailsData', this.funnelDriveData);

        if (this.funnelDriveData.registeredUsers.length === 0) {
          this.Registration = 0;
          this.RegistrationAttended = 0;
          this.RegistrationSelected = 0;
        } else {
          // console.log("this.funnelDriveData.hiringDrive.selectedUsers.length: ", this.funnelDriveData.hiringDrive.selectedUsers.length);
          // console.log("this.funnelDriveData.hiringDrive.registeredUsers.length ",
          // this.funnelDriveData.hiringDrive.registeredUsers.length);
          // console.log("this.funnelDriveData.hiringDrive.attendedUsers.length ", this.funnelDriveData.hiringDrive.attendedUsers.length);


          this.Registration = 100;
          // console.log("Funnel1",this.funnelDriveData.hiringDrive.selectedUsers.length);
          // console.log("Funnel2",this.funnelDriveData.hiringDrive.registeredUsers.length);
          // console.log("funnel3",(this.funnelDriveData.hiringDrive.selectedUsers.length /
          // this.funnelDriveData.hiringDrive.registeredUsers.length) * 100);


          this.RegistrationAttended = (this.funnelDriveData.attendedUsers.length / this.funnelDriveData.registeredUsers.length) * 100;
          // / 100;
          if (this.funnelDriveData.attendedUsers.length !== 0) {
            this.RegistrationSelected = (this.funnelDriveData.selectedUsers.length / this.funnelDriveData.attendedUsers.length) * 100;
            // / 100;
            this.RegistrationSelected = Math.floor(this.RegistrationSelected);
            this.RegistrationAttended = Math.floor(this.RegistrationAttended);

          } else {
            this.RegistrationSelected = 0;

          }
          // console.log("value of this.RegistrationSelected : ", this.RegistrationSelected);

        }

        if (this.funnelDriveData.walkinUsers.length === 0) {
          this.walkinAttended = 0;
          this.walkingSelected = 0;
        } else {
          this.walkinAttended = 100;
          this.walkingSelected = (this.funnelDriveData.walkinSelected.length / this.funnelDriveData.walkinUsers.length) * 100; // / 100;
          this.walkingSelected = Math.floor(this.walkingSelected);

        }
        this.utility.hideSpinner();
      });
  }

  openAddBranchDialog() {
    const dialogRef = this.dialog.open(AddBranchComponent, {
      // data: this.data,
      // width: '43em',
      // panelClass: "dialog-style",
      // disableClose: true
    
      height: 'fit-content',
     
      data: this.data,
      width: '50em',
      autoFocus: false,
      panelClass: "dialog-style",
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.getCollegeData();
    });
  }
  getData() {
    this.driveEventService.getDriveEvent().subscribe(
      (response: any) => {
        this.data = response;
      });
  }

  @ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;

  public scrollRight(length): void {
    //this.visibilityForLeftIcon = true;
    this.count++;
    if(this.count + 3 === length){
      console.log("this.count",this.count + 3);
      console.log("Length",length);
      this.visibilityForRightIcon = false;
    }
    else{
      this.visibilityForLeftIcon = true;
    }
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 150), behavior: 'smooth' });
  }

  public scrollLeft(): void {
    this.count--;
    if(this.count + 3 == 3) {
      this.visibilityForLeftIcon = false;
      this.visibilityForRightIcon = true;
    }
    else{
      this.visibilityForRightIcon = true;
    }
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 150), behavior: 'smooth' });
  }

  openFunnelDialog(type: any) {
    console.log("openFunnelDialog type",type);

    if (type === 'REGISTER') {
      console.log('register', this.funnelDriveData.registeredUsers);
      this.funnelData = this.funnelDriveData.registeredUsers;
    }
    if (type === 'ATTENDED') {
      console.log('attended', this.funnelDriveData.attendedUsers);
      this.funnelData = this.funnelDriveData.attendedUsers;
    }
    if (type === 'SELECTED') {
      this.funnelData = this.funnelDriveData.selectedUsers;
    }
    if (type === 'WALKINATTENDED') {
     this.funnelData =  this.funnelDriveData.walkinUsers;
    }
    if ( type === 'WALKINSELECTED') {
     this.funnelData =  this.funnelDriveData.walkinSelected;
    }
    // console.log(event, this.userInstituteList, this.single);
    console.log('fuu--', this.funnelData);

    const dialogRef = this.dialog.open(DownloadXlsxComponent, {
      width: '400px',
      data: {

        funnelData: this.funnelData,
        name: this.funnelDriveData.driveName + "_" + type,
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log( 'Triggered' );
        console.log('result here: ', result);

      }
    });
  }
}
